import React from 'react'

const CGV = () => <div>{/*<img alt="cataloge" src={`${require('../../assets/ZadigCatalogue.jpg')}`} />*/}</div>

export default CGV
